module.exports = __webpack_public_path__ + "static/media/HCMM347.c3d0ef38.jpg";